import { NavLink } from "react-router";
import t from "@/lang/lang";
import {
  BaseDataPage,
  BaseDataPageContent,
  BaseDataPageDescription,
  BaseDataPageHeader,
  BaseDataPageTitle,
} from "@/routes/base-data/_components/layout/base-data-page";
import { CreateCatalogDialog } from "@/services/backend/textblocks/components/create-catalog-dialog";
import { CatalogTable } from "@/services/backend/textblocks/components/catalog-table";
import { DefaultCatalogCard } from "@/services/backend/textblocks/components/default-catalog-card";

export function CatalogListRoute() {
  return (
    <BaseDataPage>
      <BaseDataPageHeader>
        <BaseDataPageTitle>{t("Bemerkungen Kataloge")}</BaseDataPageTitle>
        <BaseDataPageDescription>
          {t(
            "Hier können Kataloge für Bemerkungen konfiguriert werden. Diese Bemerkungen können dann in Vorgängen ausgewählt werden.",
          )}
        </BaseDataPageDescription>
      </BaseDataPageHeader>
      <BaseDataPageContent>
        <div className="grid gap-2">
          <div className="flex justify-end">
            <CreateCatalogDialog />
          </div>
          <CatalogTable
            request={{}}
            renderRowLink={(catalogId, children) => (
              <NavLink to={catalogId}>{children}</NavLink>
            )}
          />
          <DefaultCatalogCard />
        </div>
      </BaseDataPageContent>
    </BaseDataPage>
  );
}
